var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.grade !== null)?_c('div',[_c('span',{class:_vm.badgeClass},[_vm._v(_vm._s(_vm.formattedGrade))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }